import api from 'Plugins/api'
import { Popup, RadioGroup, Radio ,Cell, CellGroup, Tag, Field ,Dialog, Image as VanImage,loading,Checkbox, CheckboxGroup} from 'vant'
import { mapGetters } from 'vuex'
import { queryParameter } from 'Utils/publicApi'
import { trim } from 'Utils/string'
import { is_weixn,isH5 ,getSysType } from 'CommonUtils/plus.js'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import axiosInstance from 'Plugins/axios'
import VisaOrderInteractor from 'Domain/use-cases/visa-order-interactor'
import { formatDate, getLongStrDate } from 'Utils/dateUtil'
// import html2canvas from 'html2canvas'
import VueQr from 'vue-qr'

import alipay from 'Assets/images/pay/alipay.png'
import weixin from 'Assets/images/pay/weixin.png'
import yinlian from 'Assets/images/pay/yinlian.png'
import xieyi from 'Assets/images/pay/xieyi.png'
import cmb from 'Assets/images/pay/cmb.png'
import ysf from 'Assets/images/pay/ysf.png'
import {localget} from 'Utils/storage'

var timers = ''
export default {
  name: 'Pay',
  components:{
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [loading.name]: loading,
    [VanImage.name]: VanImage,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    ldTabbar,
    ldButton,
    VueQr
  },
  data() {
    return {
      orderNo: '',
      orderDetail: {
        orderRangeBeanList: [],
        rangeList:[]
      }, // 机票正常单 详情
      alterOrderDetail: {}, // 机票改签单 详情
      payList: [],
      subjectName:'',
      // ------------获取支付列表入参-----
      // ------支付入参--------
      payMethod: '', // 支付方式
      payRemark: '', // 支付备注
      orderList: [], // 支付订单集合
      paySubject: '', // 支付科目
      reMsg: '',
      //--------------
      orderPriceZong: '', // 该订单的总价   票价  + 服务费
      payTotalPrice: '', // 支付价格总
      newTicketPrice: '', // 新票价
      isShowPay: false, //是否显示支付按钮
      isShowKong:false, //  显示公司未设置
      channelList: {}, //支付渠道
      // 保险
      bxcpList: {},
      bxOrderList: {},
      bxprice:0,
      payPwd:'',//支付密码
      showPwd: 0,//显示支付密码参数控制
      isShowPwd: false,//显示支付密码

      isShowSms: false,
      paySms: '',
      isSendSms: false,
      smsTime: 59,
      smsBtnTxet:'获取验证码',

      manySubjects:false,//是否多科目支付
      manySubjectsArr:[],//多科目支付
      empInfo: {},
      zxzf: '',//在线支付
      zxzf1: '',//在线支付
      qr: {//二维码
        showQr: false,
        qrUrl: '',
        // logo:money,
        time: '',
        text:'',
      },
      posterDataUrl: '',
      dataBase:'',
      compNo: '',
      payHeadStyle: 'linear-gradient(180deg,#4b4b4b 0%,#5a5a5a 18%,@color-background-gray 18%,@color-background-gray 100%),linear-gradient(#45bf98,#45bf98);',
      ssoParam: null,
    }
  },
  computed: {
    ...mapGetters({
      tripType: 'tripType',
      userInfo: 'userInfo',
      loginConfig:'loginConfig'
    }),
    orderId(){
      return this.$route.query.orderId
    },
    orderType(){
      return this.$route.query.orderType
    },
  },
  created () {
    this.init()
  },
  beforeDestroy() {
    if (this.tnTimer || this.timer) {
      clearInterval(this.tnTimer) //关闭定时器
      this.tnTimer = null
      clearInterval(this.timer) //关闭定时器
      this.timer = null
    }
  },
  mounted () {
    let state = localget('VUEX_STATE') || {}
    if (state.app && state.app.loginConfig) {
      this.compNo = state.app.loginConfig.by4
    }

    // 单点登录
    // var ssoParam = {
    // private BigDecimal amount;//支付金额 单位元
    // private String payEndTime;//最后支付时间 yyyy-MM-dd HH:mm:ss
    // private String returnUrl;//页面回调地址
    // private String notifyUrl;//支付回调地址
    // private String orderDesc;//订单描述
    // private String changeType;//改签类型 1高改低 2低改高 高改低的时候 需要页面给提示
    // private String extraInfo;//扩展信息 下单时需要
    // }
    this.ssoParam = this.userInfo.empInfo.ssoJsonParam && this.userInfo.empInfo.ssoJsonParam.payData
  },
  methods: {
    isH5,
    init () {
      axiosInstance.defaults.headers['y-cli'] = getSysType()

      /**
       * 20021 是否需要输入密码
       * 20025 “酒店参数设置”--“超差旅标准部分允许个人支付”
       */
      if (this.tripType == 1) {
        var self = this
        queryParameter('20021,20025').then(arr => {
          if (arr && arr.length) {
            arr.forEach(item => {
              if (item.paramNo == '20021') {
                self.showPwd = item.value1
              } else if (item.paramNo == '20025') {
                if (this.orderType == '11007') {//(暂时只有酒店正常单使用)
                  self.manySubjects = item.value1 == 1 ? true : false
                }
              }
            })
          }
          self.getOrder()
        })
      } else {
        this.getOrder()
      }

      if (isH5() == false) { //非h5环境下执行
        //获取支付通道列表
        this.payAppInfo()
      }
    },
    //获取支付通道列表
    payAppInfo() {
      var self = this
      //获取支付列表
      plus.payment.getChannels(function (channels) {
        //[{"id":"alipay","description":"支付宝","serviceReady":true},{"id":"wxpay","description":"微信","serviceReady":true}]
        console.log(channels)
        for(var i in channels) {
          var channel = channels[i] //获取支付通道
          self.channelList[channel.id] = channel
          // if(channel.id == 'qhpay' || channel.id == 'qihoo') { //过滤掉不支持的支付通道：暂不支持360相关支付
          // 	continue
          // } else
          if (channel.id == 'alipay') {
            // channel.serviceReady //获取是是否安装支付宝
            if (channel.serviceReady==false) {
              plus.nativeUI.confirm('检测到系统未安装“支付宝快捷支付服务”，无法完成支付操作，是否立即安装？', function (e) {
                if (e.index == 0) {
                  channel.installService()
                }
              }, channel.description)
            }
          } else if (channel.id == 'wxpay') {
            if (channel.serviceReady==false) {
              plus.nativeUI.confirm('检测到系统未安装“微信客户”，无法完成支付操作，是否立即安装？', function (e) {
                if (e.index == 0) {
                  channel.installService()
                }
              }, channel.description)
            }
          }
        }
      }, function (e) {
        console.log('获取支付通道失败：'+e.message)
      })
    },
    // 调用各个产品订单详情
    getOrder () {
      let orderType = this.orderType
      let orderId = this.orderId
      let obj = {
        '11001': 'getOrderDetail', //机票正常单
        '11004': 'getOrderDetail', //机票正常单
        '11003': 'getAlertOrderDetail', //机票改签单
        '11006': 'getAlertOrderDetail', //机票改签单
        '11009': 'getTrainOrderDetail',// 火车票正常单
        '11011': 'getTrainAlterDetail',// 火车票改签单
        '11007': 'gethotelOrderDetail',// 酒店正常单
        '11018': 'getCarBookDetail',// 用车
        // '11012': 'getAirServiceDetail',// 机场服务 旧版
        // '11019': 'getAgentOrderDetail',// 代办值机 旧版
        '11023': 'getVisaDetail',// 签证
        '11028': 'getAirServiceDetailNew',// 休息室  2021-01-06
        '11029': 'getAirServiceDetailNew',// 快速安检
        '11030': 'getAirServiceDetailNew',// 优选值机
        '11031': 'getAirServiceDetailNew',// 要客通
      }
      let fun=obj[orderType]||''
      if (fun) {
        this[fun](orderId)
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '产品类型传入错误！错误值'+ orderType,
        }).then(() => {
          // on close
        })
      }
    },

    //------------------------获取订单详情- START--------------------  //
    //获取机票正常单 详情   ajax
    getOrderDetail(id) {
      this.$api['tkOrder/orderDetail']({
        id: id
      }).then(resp => {
        this.orderDetail = resp.data || {}
        this.orderNo = this.orderDetail.orderNo
        this.orderPriceZong = this.orderDetail.totalPrice
        this.payTotalPrice = this.orderDetail.totalPrice + this.orderDetail.bxPrice
        this.getBxOrderDetailByOrderId()
      })
    },
    // 获取 改签单支付详情
    getAlertOrderDetail(id) {
      this.$api['tkOrder/tkChangeOrderDetail']({
        changeOrderId: id
      }).then(resp=> {
        this.alterOrderDetail = resp.data || {}
        this.orderNo = this.alterOrderDetail.changeNo
        this.orderPriceZong = this.alterOrderDetail.changeAmount
        this.payTotalPrice = this.alterOrderDetail.changeAmount
        // 无保险订单 可直接获取支付科目
        this.getPaySubject([{
          'orderId': this.orderId,
          'orderType': this.orderType
        }])
      }).catch(() =>{
        this.isShowPay = false
      })
    },
    // 获取火车正常单详情
    getTrainOrderDetail(id) {
      this.$api['trOrder/detail']({
        id: id
      }).then(resp=> {
        this.orderDetail = resp.data || {}
        this.orderNo = this.orderDetail.orderNo
        this.orderPriceZong = Number(this.orderDetail.ticketPrice) + Number(this.orderDetail.sellServiceCharge)
        this.payTotalPrice = Number(this.orderDetail.ticketPrice) + Number(this.orderDetail.sellServiceCharge) + Number(this.orderDetail.bxPrice)
        this.getBxOrderDetailByOrderId()
      })
    },
    // 获取火车改签单详情
    getTrainAlterDetail(id) {
      this.$api['trOrder/changeDetail']({
        changeId: id
      }).then(resp=> {
        this.orderDetail = resp.data || {}
        this.orderNo = this.orderDetail.changeNo
        this.orderPriceZong = this.orderDetail.changeAmount
        this.payTotalPrice = this.orderDetail.changeAmount
        this.newTicketPrice = this.orderDetail.newTicketPrice + this.orderDetail.buyChangePoundage + this.orderDetail.buyServiceCharge
        // 无保险订单 可直接获取支付科目
        this.getPaySubject([{
          'orderId': this.orderId,
          'orderType': this.orderType
        }])
      })

    },
    // 获取保险单详情
    getBxOrderDetailByOrderId () {
      var arr = [{
        'orderId': this.orderId,
        'orderType': this.orderType
      }]
      this.$api['bx/getBxOrderListByGlddId']({
        glddId: this.orderId
      }).then(res=> {
        var data = res.data || []
        if (data.length > 0) {
          this.bxOrderList=data
          const bxcpList = {}
          // 按 bxcpmc 分组
          for (let i = 0; i < data.length; i++) {
            if (!bxcpList[data[i].bxcpmc]) {
              bxcpList[data[i].bxcpmc] = data[i]
            }
          }
          this.bxcpList = bxcpList

          data.forEach((item)=> {
            arr.push({
              'orderId': item.id,
              'orderType': '11015'
            })
            this.bxprice += item.xsj
          })
          if(isNaN(this.bxprice)){
            this.bxprice = 0
          }
        }
        this.getPaySubject(arr)
      })
    },
    //  获取酒店正常单详情
    gethotelOrderDetail(id) {
      this.$api['htQuery/hotelOrderDetail']({
        orderId: id
      }).then(resp=> {
        this.orderDetail = resp.data || {}
        this.orderNo = this.orderDetail.orderNo
        this.orderDetail._rzrqweek = formatDate(this.orderDetail.rzrq).week
        this.orderPriceZong = this.orderDetail.totalPrice
        this.payTotalPrice = this.orderDetail.totalPrice
        if (!this.orderDetail.grzfje) {
          this.manySubjects=false
        }
        // 无保险订单 可直接获取支付科目
        this.getPaySubject([{
          'orderId': this.orderId,
          'orderType': this.orderType
        }])
      })
    },
    // 获取用车订单详情
    getCarBookDetail(id){
      this.$api['carOrder/QueryCarOrderDetail']({
        orderId: id
      }).then(res => {
        this.orderDetail = res.data || {}
        this.orderNo = this.orderDetail.orderNo
        this.orderPriceZong = this.orderDetail.totalAmount
        this.payTotalPrice= this.orderDetail.totalAmount
        this.getPaySubject([{
          'orderId': this.orderId,
          'orderType': this.orderType
        }])
      })
    },
    // 获取签证订单详情
    async getVisaDetail (id) {
      const { data } = await VisaOrderInteractor.getDetailById(id)
      this.orderDetail = data
      this.orderNo = this.orderDetail.orderNo
      this.orderPriceZong = this.orderDetail.totalPrice
      this.payTotalPrice= this.orderDetail.totalPrice
      this.getPaySubject([{
        'orderId': this.orderId,
        'orderType': this.orderType
      }])
    },
    // 获取  机场服务详情 新 2021-01-06
    getAirServiceDetailNew (id) {
      this.$api['airService/orderDetail']({orderId:id}).then((res) => {
        let cache=res.data||{}
        this.orderDetail = cache
        this.orderNo = cache.orderNo
        this.orderPriceZong=cache.totalAmount
        this.payTotalPrice=cache.totalAmount
        this.getPaySubject([{
          'orderId': this.orderId,
          'orderType': this.orderType
        }])
      })
    },

    //------------------------获取订单详情- END----------------------//

    //根据订单类型获取支付场景
    getPayScene (orderType) {
      //APP 支付场景获取的数组
      var payConfigApp = {
        11001: '12711', //国内机票正常单
        //	11002 : '', //国内机票退票单
        11003: '12712', //国内机票改签单
        11004: '12732', //国际机票正常单
        //	11005 : '', //国际机票退票单
        11006: '12733', //国际机票改签单
        11007: '12715', //酒店正常单
        //	11008 : '', //酒店退单
        11009: '12713', //火车票正常单
        //	11010 : '', //火车票退票单
        11011: '12714', //火车票改签单
        // 11012: '12722', //机场服务订单
        //	11013 : '', //接送机订单
        11014: '12719', //代客泊车订单
        //	11015 : '', //保险订单
        //	11016 : '', //结欠单
        //	11017 : '', //结算单
        11018: '12718', // 用车订单
        // 11019: '12725', //  代办值机
        11020: '', // 机场服务退票单
        11023: '12736', // 签证订单

        11028: '12742',//休息室  2021-01-06
        11029: '12743',//快速安检
        11030: '12744',//优选值机
        11031: '12745',//要客通
      }
      //H5 支付场景获取的数组
      var payConfigH5 = {
        11001: '12706', //国内机票正常单
        //	11002 : '', //国内机票退票单
        11003: '12707', //国内机票改签单
        11004: '12730', //国际机票正常单
        //	11005 : '', //国际机票退票单
        11006: '12731', //国际机票改签单
        11007: '12710', //酒店正常单
        11008: '', //酒店退单
        11009: '12708', //火车票正常单
        //		11010 : '', //火车票退票单
        11011: '12709', //火车票改签单
        // 11012: '12724', //机场服务订单
        //	11013 : '', //接送机订单
        11014: '12721', //代客泊车订单
        //	11015 : '', //保险订单
        //	11016 : '', //结欠单
        //	11017 : '', //结算单
        11018: '12717', // 用车
        // 11019: '12727', //  代办值机
        11023: '12735', // 签证订单

        11028: '12738',//休息室  2021-01-06
        11029: '12739',//快速安检
        11030: '12740',//优选值机
        11031: '12741',//要客通
      }
      //小程序
      var payConfigMiniprogram = {
        11001:12746,//    国内机票订单支付
        11003:12747,//    国内机票改签订单支付
        11009:12748,//    火车票订单支付
        11011:12749,//    火车改签支付
        11007:12750,//    酒店订单支付
        11018:12751,//    用车订单支付
        11014:12752,//    代客泊车订单支付
        // 11012:12753,//    机场服务订单支付
        // 11019:12754,//    代办值机订单支付
        11004:12755,//    国际订单支付
        11006:12756,//    国际改签订单支付
        11023:12757,//    签证订单支付
        11028:12758,//    休息室订单支付
        11029:12759,//    快速安检订单支付
        11030:12760,//    优选值机订单支付
        11031:12761,//    要客通订单支付
      }

      var payScene = '' //支付场景
      if (isH5()) {
        if (window.wx_min) {//小程序
          payScene = payConfigMiniprogram[orderType] || ''
        } else {
          payScene = payConfigH5[orderType] || ''
        }
      } else {
        payScene = payConfigApp[orderType] || ''
      }
      if (payScene) {
        return payScene
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '未找到对应的支付场景！',
        }).then(() => {
          // on close
        })
      }
    },
    // 不参与 保险的产品
    //获取支付科目  并且 获取 支付场景
    getPaySubject (arr) {
      this.payList = []
      let that = this
      this.$api['common/getPaySubject']({
        'orderBeans': arr,
        'payScene': this.getPayScene(this.orderType) //获取对应的支付场景   机票正常单   12706  ； 机票改签单  12707
      }).then(res => {
        let cache = res.data || {}
        let paySubjects = cache.paySubjects || []
        if (paySubjects.length) {
          var arr = [], obj = ''
          paySubjects.forEach(el => {
            el.disabled=false
            if (el.payMethod == '12104'&&el.zxzf == 'cmb') {
              obj = el
            } else {
              arr.push(el)
            }
          })
          if (obj) {
            arr.push(Object.assign({}, obj, { subjectName: '支付宝扫码支付' }, { zflx: 'zfb' }))
            arr.push(Object.assign({}, obj, { subjectName: '微信扫码支付' }, { zflx: 'wx' }))
          }
          this.payList = arr
          this.isShowKong = false
          // 是否多科目支付
          if (this.manySubjects) {
            this.manySubjectsPayInit()
          }
        } else {
          this.isShowKong = true
        }

        //  判断价格是否变动
        if(cache.isChangePrice==1){
          this.$dialog.confirm({ message: '航班价格发生变动！重新获取订单详情后，方可支付！' }).then(()=>{
            that.getOrder()
          })
        }
      }).catch(() =>{
        this.isShowPay = false
        this.isShowKong = true
      })
    },
    // 多科目支付 初始化
    manySubjectsPayInit () {
      this.manySubjectsArr = []
      //'当前订单是否需要多科目支付'
      if (this.payList.length == 1) {
        this.$toast('超额无法支付！')
        return
      } else {
        //锁定协议欠款
        this.payList.forEach(item => {
          // 默认选中协欠 并且不可修改
          if (item.subjectId=='1210501') {
            item.disabled = true
            this.manySubjectsArr.push(item)
            console.log(this.manySubjectsArr)
          }
        })
      }
    },
    //去支付
    //点击下单按钮
    toPayCompelete() {
      if (this.orderType == 11009 && this.orderDetail.isNoseat == 1) {
        this.$dialog.confirm({
          title: this.$t('C474','提示'),
          message: '当前订单的座位席别包含无座，请您确认是否继续支付'
        }).then(() => {
          this.pwdCtrl()
        })
      } else if (this.ssoParam && this.ssoParam.changeType && this.ssoParam.changeType == 2 && this.ssoParam.amount != this.newTicketPrice) {
        this.$dialog.alert({
          title: this.$t('C474','提示'),
          message: '支付失败，实际支付金额与订单验价金额不一致，请重新发起支付！'
        })
      } else if (this.ssoParam && this.ssoParam.amount != this.payTotalPrice) {
        this.$dialog.alert({
          title: this.$t('C474','提示'),
          message: '支付失败，实际支付金额与订单验价金额不一致，请重新发起支付！'
        })
      } else if (this.ssoParam && this.ssoParam.payEndTime < getLongStrDate()) {
        this.$dialog.alert({
          title: this.$t('C474','提示'),
          message: '支付失败，订单支付超时，请重新发起支付！'
        })
      } else {
        this.pwdCtrl()
      }
    },
    // 密码
    pwdCtrl () {
      console.log('支付',this)
      if (this.payMethod == 12105) {
        if (this.showPwd == 2) {//显示验证码
          this.isShowSms = true
        } else if (this.showPwd == 1) {//显示支付密码
          this.isShowPwd = true
        } else {
          this.toPayAjax()
        }
      } else {
        this.toPayAjax()
      }
    },
    // 密码回调
    pwdConfirm () {
      this.payPwd = trim(this.payPwd)
      if (this.payPwd) {
        this.isShowPwd=false
        this.toPayAjax()
      }else{
        this.$toast('支付密码有误！')
      }
    },
    //发送验证码
    sendSms () {
      this.$api['common/getSmsCode']({
        'orderId': this.orderId,
        'orderNo': this.orderNo,
        'orderType': this.orderType
      }).then(() => {
        this.isSendSms = true
        let time = setInterval(() => {
          this.smsTime -= 1
          if (this.smsTime<=0) {
            this.isSendSms = false
            this.smsTime = 59
            this.smsBtnTxet = '重新发送'
            clearInterval(time)
            time=''
            return
          }
        },1000)
      })
    },
    // 验证码回调
    smsConfirm () {
      this.paySms = trim(this.paySms)
      if (this.paySms) {
        this.$api['common/smsCodeCheck']({
          smsCode:this.paySms
        }).then(res => {
          let cache = res.data || {}
          if (cache.checkResult == 1) {
            this.toPayAjax()
            this.isShowSms=false
          } else {
            this.$toast(cache.cause)
          }
        })
      }else{
        this.$toast('请输入短信验证码！')
      }
    },
    //点击支付按钮
    toPayAjax () {
      let orderList = [{
        'orderId': this.orderId,
        'orderNo': this.orderNo,
        'orderType': this.orderType,
        'payAmount': this.orderPriceZong,
        'payRemark': this.getPayRemark(this.orderType)
      }]
      // 保险订单
      if (this.bxOrderList.length) {
        this.bxOrderList.forEach(item => {
          orderList.push({
            'orderId': item.id,
            'orderType': '11015',
            'orderNo': item.orderNo,
            'payAmount': item.xsj,
            'payRemark': item.xzmc + ' ' + item.bbr
          })
        })
      }

      let subjectBeanList = []//多科目集合
      //多科目支付
      if (this.manySubjects) {
        if (this.manySubjectsArr.length == 1) {
          this.$toast('请选择支付科目！')
          return
        }
        this.manySubjectsArr.forEach(item => {
          subjectBeanList.push({
            'payMethod': item.payMethod,
            'paySubject': item.subjectId,
            'payAmount': this.getPayAmount(item),
            'jfAmount': '',//价格说明 用来存积分的兑换金额
          })
          if (item.payMethod != '12105') {//筛选出非公司的支付方式
            this.zxzf = item.zxzf
          }
        })
      } else {
        subjectBeanList = [{
          'payMethod': this.payMethod,
          'paySubject': this.paySubject,
          'payAmount': this.payTotalPrice,
          'jfAmount': '',//价格说明 用来存积分的兑换金额
        }]
      }

      var queryString = {
        'orderList': orderList,
        'payPwd': this.payPwd,
        'payScene': this.getPayScene(this.orderType),//获取对应的支付场景
        'subjectBeanList': subjectBeanList,//多科目
        'webHost':process.env.VUE_APP_addressUrl || '',//安卓、ios客户调用支付时，虚拟的访问网站域名。客户端必传
        'zcyh':is_weixn()?'wx':'',//公众号 招行二维码  判断微信还是支付宝
        'buyerId': is_weixn() ? localStorage.getItem('openId') : '',// 微信用户的openId
      }

      let that = this
      // 请求
      let newUrl = that.zxzf== 'ylcp' ? 'common/onlinePayNewUnionpayCp' : 'common/onlinePayNew'
      this.$api[newUrl](queryString).then(resp => {
        let cache = resp.data || {}
        let reMsg=cache.reMsg||''
        that.payInfoId = cache.payInfoId
        let wxPayData = cache.wxPayData || {}
        if (cache.failMsg) {
          this.$toast(cache.failMsg)
        }
        // 创建一个支付div;
        var el =document.getElementById('pay_no_replay')
        if(el) {
          el.parentNode.removeChild(el)
          el = null
        }
        var div = document.createElement('div')
        div.setAttribute('id', 'pay_no_replay')
        document.body.appendChild(div)
        console.log('支付方式', that.zxzf)
        if (that.zxzf == 'cmb') {//招行二维码
          if (this.zxzf1 == 'zfb') {
            let a = document.getElementById('link')
            a.href = 'alipayqr://platformapi/startapp?saId=10000007&qrcode='+this.reMsg
            a.click()
            setTimeout(function () {
              that.$dialog.confirm({
                title: '提示',
                message: '',
                confirmButtonText:'已支付',
                cancelButtonText:'支付遇到问题',
              }).then(() => {
                clearInterval(timers.tId)
                that.$router.push({
                  path: '/tk/paySuccess', query: {
                    orderId: that.orderId, orderType: that.orderType
                  }
                })
              }).catch(() => {
                clearInterval(timers.tId)
                that.$toast('请重新发起支付')
              })
            },6000)
          } else if (this.zxzf1 == 'wx') {
            if (queryString.zcyh) {
              if (typeof WeixinJSBridge == 'undefined'){
                if( document.addEventListener ){
                  // eslint-disable-next-line no-undef
                  document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
                }else if (document.attachEvent){
                  // eslint-disable-next-line no-undef
                  document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
                  // eslint-disable-next-line no-undef
                  document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
                }
              } else {
                wxPayData.package=wxPayData.prepayId
                that.onBridgeReady(wxPayData)
              }
            } else {
              that.qr.showQr = true
              that.qr.qrUrl=''
              that.qr.qrUrl = reMsg||''
              /**
               * 页面定时器 + 查询后台
               * */
              var ajaxing=false
              var min = 5, sec = 59
              timers = function () {
                that.qr.time = ('0' + min + ':' + (sec < 10 ? '0' + sec : sec))
                timers.tId = setInterval(function(){
                  sec --//秒减一
                  if( sec < 0 ){
                    min--
                    sec = 59
                  }
                  if (min < 0) {
                    clearInterval(timers.tId)
                    that.$dialog({
                      title: '提示',
                      message: '支付超时',
                    }).then(() => {
                      clearInterval(timers.tId)
                    })
                  }else{
                    that.qr.time=( '0' + min + '分' + (sec < 10 ? '0' + sec : sec)+'秒')
                    //如果不处于ajax状态中
                    if (!ajaxing) {
                      ajaxing=true
                      that.$api['common/queryOnlinePayStatus']({
                        orderType : that.orderType,
                        orderId : that.orderId
                      }).then( res => {
                        var data = res.data || {}
                        ajaxing = false
                        if (data.paid == 1) {//已经支付
                          clearInterval(timers.tId)
                        }
                      })
                    }
                  }
                }, 1000)
              }
              timers()
            }
          }
        }else if (that.zxzf == 'yop'){ //易宝
          let a = document.getElementById('link')
          a.href = reMsg
          a.click()
          let tId=setTimeout(function () {
            that.$dialog.confirm({
              title: '提示',
              message: '',
              confirmButtonText:'已支付',
              cancelButtonText:'支付遇到问题',
            }).then(() => {
              clearInterval(tId)
              that.$router.push({
                path: '/tk/paySuccess', query: {
                  orderId: that.orderId, orderType: that.orderType
                }
              })
            }).catch(() => {
              clearInterval(tId)
              that.$toast('请重新发起支付')
            })
          },6000)
        }else if (that.zxzf == 'wftzf'  || that.zxzf == 'XTYPAY') {//威富通或小通云
          if (window.wx_min && that.zxzf == 'XTYPAY') {//小程序支付
            try {
              wxPayData.package = wxPayData.prepayId
              console.log(wxPayData)
              var paramspay=encodeURIComponent(JSON.stringify(wxPayData))
              // eslint-disable-next-line no-undef
              wx.miniProgram.navigateTo({//
                url: '/pages/pay/index?query='+paramspay,
                events: {
                  // 为指定事件添加一个监听器，获取被打开页面传送到当前页面的数据
                  acceptDataFromOpenedPage: function(data) {
                    console.log(1,data)
                  },
                  someEvent: function(data) {
                    console.log(2,data)
                  }
                },
                success: function (res) {
                  // 通过eventChannel向被打开页面传送数据
                  res.eventChannel.emit('acceptDataFromOpenerPage', {data:paramspay})
                }
              })
              setTimeout(function () {
                that.$dialog.confirm({
                  title: '提示',
                  message: '',
                  confirmButtonText:'已支付',
                  cancelButtonText:'支付遇到问题',
                }).then(() => {
                  that.$router.push({
                    path: '/tk/paySuccess', query: {
                      orderId: that.orderId, orderType: that.orderType
                    }
                  })
                  if(timers){
                    clearInterval(timers.tId)
                  }
                }).catch(() => {
                  that.$toast('请重新发起支付')
                  if(timers){
                    clearInterval(timers.tId)
                  }
                })
              },4000)
            } catch (error) {
              that.$toast(error)
            }
          }else{
            that.qr.showQr = true
            that.qr.qrUrl=''
            that.qr.qrUrl = reMsg||''
            /**
           * 页面定时器 + 查询后台
           * */
            let ajaxing=false
            let min = 5, sec = 59
            timers = function () {
              that.qr.time = ( '0' + min + ':' + (sec < 10 ? '0' + sec : sec))
              timers.tId = setInterval(function(){
                sec --//秒减一
                if( sec < 0 ){
                  min--
                  sec = 59
                }
                if (min < 0) {
                  clearInterval(timers.tId)
                  that.$dialog({
                    title: '提示',
                    message: '支付超时',
                  }).then(() => {
                    clearInterval(timers.tId)
                  })
                }else{
                  that.qr.time=( '0' + min + '分' + (sec < 10 ? '0' + sec : sec)+'秒')
                  //如果不处于ajax状态中
                  if (!ajaxing) {
                    ajaxing=true
                    that.$api['common/queryOnlinePayStatus']({
                      orderType : that.orderType,
                      orderId : that.orderId
                    }).then( res => {
                      var data = res.data || {}
                      ajaxing = false
                      if (data.paid == 1) {//已经支付
                        clearInterval(timers.tId)
                      }
                    })
                  }
                }
              }, 1000)
            }
            timers()
          }
        }else if (that.zxzf == 'ali102') {// 支付宝app支付
          plus.payment.request(that.channelList['alipay'], reMsg, function() {
            // outLine('----- 支付成功 -----');
            plus.nativeUI.alert('支付成功：\n感谢您的支持，我们将竭诚为您服务！\n祝您旅途愉快！',function(){
              that.$router.push({
                path: '/tk/paySuccess', query: {
                  orderId: that.orderId, orderType: that.orderType
                }
              })
            })
          }, function (e) {
            var messageObj = {
              '62000': '客户端未安装支付通道依赖的服务',
              '62001': '您取消支付操作',
              '62002': '此设备不支持支付',
              '62003': '数据格式错误',
              '62004': '支付账号状态错误',
              '62005': '订单信息错误',
              '62006': '付操作内部错误',
              '62007': '支付服务器错误',
              '62008': '网络问题引起的错误',
              '62009': '其它未定义的错误',
              '-100' : '您已取消支付'
            }
            var message
            if(e.code && messageObj[e.code]) {
              message = messageObj[e.code]
            }
            plus.nativeUI.alert('支付失败！' + (message || ''))
            //plus.nativeUI.alert('更多错误信息请参考支付(Payment)规范文档：http://www.html5plus.org/#specification#/specification/Payment.html', null, '支付失败：'+e.code);
          })
        }else if(that.zxzf== 'YL002' || that.zxzf== 'YL003'){   //  银联支付  YL001   PC   YL002 APP   YL003
          that.$nextTick(() =>{
            if(reMsg) {
              div.innerHTML = reMsg
              var forms=	document.querySelectorAll('#pay_no_replay  form')
              forms[0].submit()
            }
          })
        }else if(that.zxzf== 'ylcp'){ //银联cp支付
          if (reMsg == 'success0005'){ //0005手机控件支付
            that.$toast.loading({
              message: '加载中...',
              forbidClick: true,
              loadingType: 'spinner',
              duration:0
            })
            var tnNo = ''
            this.tnTimer = setInterval(async () => {
              if (tnNo == '' || tnNo == null) {
                await that.$api['common/unionpayCpTn']({payInfoId:that.payInfoId}).then((res) => {
                  if (res.data) {
                    tnNo = res.data.tn
                  }
                })
              } else {
                that.$toast.clear()
                setTimeout(() => {
                  that.upsdkReady(tnNo,that)
                }, 500)
                clearInterval(this.tnTimer)
                this.tnTimer = null
                return
              }
            }, 1000)
          }else { //0001支付
            if(that.reMsg){
              document.writeln(that.reMsg)
            }
          }
        }else if (that.zxzf == 'wx200' || that.zxzf == 'wx202' || that.zxzf =='tlwxzf'){   //  200  pc  201 app    202  h5
          if (isH5()) {// 如果H5页面
            if (window.wx_min) {//小程序支付
              try {
                wxPayData.package = wxPayData.prepayId
                console.log(wxPayData)
                var paramspay=encodeURIComponent(JSON.stringify(wxPayData))
                // eslint-disable-next-line no-undef
                wx.miniProgram.navigateTo({//
                  url: '/pages/pay/index?query='+paramspay,
                  events: {
                    // 为指定事件添加一个监听器，获取被打开页面传送到当前页面的数据
                    acceptDataFromOpenedPage: function(data) {
                      console.log(1,data)
                    },
                    someEvent: function(data) {
                      console.log(2,data)
                    }
                  },
                  success: function (res) {
                    // 通过eventChannel向被打开页面传送数据
                    res.eventChannel.emit('acceptDataFromOpenerPage', {data:paramspay})
                  }
                })
                setTimeout(function () {
                  that.$dialog.confirm({
                    title: '提示',
                    message: '',
                    confirmButtonText:'已支付',
                    cancelButtonText:'支付遇到问题',
                  }).then(() => {
                    that.$router.push({
                      path: '/tk/paySuccess', query: {
                        orderId: that.orderId, orderType: that.orderType
                      }
                    })
                    if(timers){
                      clearInterval(timers.tId)
                    }
                  }).catch(() => {
                    that.$toast('请重新发起支付')
                    if(timers){
                      clearInterval(timers.tId)
                    }
                  })
                },4000)
              } catch (error) {
                that.$toast(error)
              }
            }else if (typeof WeixinJSBridge == 'undefined'){
              that.$nextTick(() =>{
                if(reMsg) {
                  window.location.href = reMsg+'&redirect_url='+(that.loginConfig.domainName?('https://'+that.loginConfig.domainName):process.env.VUE_APP_addressIp)+'/#/pay/paySuccess'
                  // div.innerHTML = '<form id="payForm" method="post"></form>';
                  // var form =	document.getElementById("payForm");
                  // form.action = reMsg;
                  // form.submit();
                }
              })
            } else {
              wxPayData.package=wxPayData.prepayId
              that.onBridgeReady(wxPayData)
            }
          }else{//app
            var u=encodeURI((that.loginConfig.domainName?('https://'+that.loginConfig.domainName):process.env.VUE_APP_addressIp)+'/#/pay/paySuccess')
            var uurl = reMsg + '&redirect_url=' + u
            plus.webview.open(uurl,'payurl',{
              additionalHttpHeaders: {
                referer:  (that.loginConfig.domainName?('https://'+that.loginConfig.domainName):process.env.VUE_APP_addressIp)
              },
              titleNView: {
                autoBackButton:false,
                buttons: [ //Array[ WebviewCustomButtonStyles ]类型,标题栏上的自定义按钮.建的自定义按钮数目不限制,实际应用中建议最多设置4个按钮(包括左侧返回按钮).
                  {
                    color: '', //String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为窗口标题栏控件的标题文字颜色.
                    colorPressed: '', //String类型,按下状态按钮文字颜色.String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为color属性值自动调整透明度为0.3.
                    float: 'right', //String类型,按钮在标题栏上的显示位置.right:在标题栏中靠右排列显示.left:在标题栏中靠左侧排列显示(在返回键后). 默认:right.
                    fontWeight: '', //String类型,按钮上文字的粗细.normal:标准字体.bold:加粗字体.默认:normal.
                    fontSize: '14px', //String类型,按钮上文字大小.可取值:字体高度像素值,数字加"px"格式字符串.
                    fontSrc: '', //String类型,按钮上文字使用的字体文件路径.相对路径:相对于当前页面的host位置,如"a.jpg",注意当前页面为网络地址则不支持.绝对路径:如Android平台"/sdcard/logo.png",此类路径通常通过其它5+ API获取的.扩展相对路径URL(RelativeURL):以"_"开头的相对路径,如"_www/a.jpg".本地路径URL:以"file://"开头,后面跟随系统绝对路径.
                    onclick: function(){
                      //var ws=plus.webview.currentWebview();
                      plus.webview.close('payurl')
                      //thst.goback();
                    }, //WebviewCustomButtonCallback类型,按钮点击后触发的回调函数.回调函数中将返回此JSON对象
                    text: '关闭' //String类型,按钮上显示的文字.推荐使用一个字符,超过一个字符可能无法正常显示,使用字体图标时unicode字符表示必须'\u'开头,如"\ue123"(注意不能写成"\e123").
                  }
                ],
                backButtonAutoControl: 'close'
              }
            })

            setTimeout(() => {
              plus.webview.close('payurl')
            }, 2000)

            plus.webview.open(u,'paysuccess',{
              autoBackButton:false,
              buttons: [ //Array[ WebviewCustomButtonStyles ]类型,标题栏上的自定义按钮.建的自定义按钮数目不限制,实际应用中建议最多设置4个按钮(包括左侧返回按钮).
                {
                  color: '', //String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为窗口标题栏控件的标题文字颜色.
                  colorPressed: '', //String类型,按下状态按钮文字颜色.String类型,按钮上文字颜色.可取值:"#RRGGBB"格式字符串,"rgba(R,G,B,A)".默认值为color属性值自动调整透明度为0.3.
                  float: 'right', //String类型,按钮在标题栏上的显示位置.right:在标题栏中靠右排列显示.left:在标题栏中靠左侧排列显示(在返回键后). 默认:right.
                  fontWeight: '', //String类型,按钮上文字的粗细.normal:标准字体.bold:加粗字体.默认:normal.
                  fontSize: '14px', //String类型,按钮上文字大小.可取值:字体高度像素值,数字加"px"格式字符串.
                  fontSrc: '', //String类型,按钮上文字使用的字体文件路径.相对路径:相对于当前页面的host位置,如"a.jpg",注意当前页面为网络地址则不支持.绝对路径:如Android平台"/sdcard/logo.png",此类路径通常通过其它5+ API获取的.扩展相对路径URL(RelativeURL):以"_"开头的相对路径,如"_www/a.jpg".本地路径URL:以"file://"开头,后面跟随系统绝对路径.
                  onclick: function(){
                    //var ws=plus.webview.currentWebview();
                    plus.webview.close('paysuccess')
                    that.goback()
                  }, //WebviewCustomButtonCallback类型,按钮点击后触发的回调函数.回调函数中将返回此JSON对象
                  text: '关闭' //String类型,按钮上显示的文字.推荐使用一个字符,超过一个字符可能无法正常显示,使用字体图标时unicode字符表示必须'\u'开头,如"\ue123"(注意不能写成"\e123").
                }
              ],
              backButtonAutoControl: 'close'
            })
          }

        }else if (that.zxzf == 'wx201') {//微信app支付
          console.log('通道',that.channelList['wxpay'])
          let wxPayParams = {
            appid: wxPayData.appId,
            partnerid: wxPayData.partnerid,
            prepayid:wxPayData.prepayId,
            package: 'Sign=WXPay',
            noncestr:wxPayData.nonceStr,
            timestamp:wxPayData.timeStamp,
            sign: wxPayData.paySign,
          }
          var address=''
          try {
            address = JSON.stringify(wxPayParams)
          } catch (error) {
            console.log(error)
            address = wxPayParams
          }
          console.log('参数',address)
          plus.payment.request(that.channelList['wxpay'], address , function() {
            plus.nativeUI.alert('支付成功：\n感谢您的支持，我们将竭诚为您服务！\n祝您旅途愉快！',function(){
              that.$router.push({
                path: '/tk/paySuccess', query: {
                  orderId: that.orderId, orderType: that.orderType
                }
              })
            })
          }, function (e) {
            var messageObj = {
              '62000': '客户端未安装支付通道依赖的服务',
              '62001': '您取消支付操作',
              '62002': '此设备不支持支付',
              '62003': '数据格式错误',
              '62004': '支付账号状态错误',
              '62005': '订单信息错误',
              '62006': '付操作内部错误',
              '62007': '支付服务器错误',
              '62008': '网络问题引起的错误',
              '62009': '其它未定义的错误',
              '-100': '您已取消支付!',
              // 微信报错代码
              '-1': '签名错误、未注册APPID、项目设置APPID不正确、注册的APPID与设置的不匹配、其他异常原因等',//错误
              '-2': '您已取消支付!',//'用户取消	无需处理。发生场景：用户不支付了，点击取消，返回APP'
              '-3':'发送失败',
              '-4':'认证被否决',
              '-5':'不支持错误'
            }
            console.log('error',e)
            var message
            if(e.code && messageObj[e.code]) {
              message = messageObj[e.code]
            }
            plus.nativeUI.alert('支付失败！' + (message || ''))
            //plus.nativeUI.alert('更多错误信息请参考支付(Payment)规范文档：http://www.html5plus.org/#specification#/specification/Payment.html', null, '支付失败：'+e.code);
          })
        }else if(that.zxzf == 'ali101'){ // 支付宝 手机网站    12104
          that.$nextTick(function() {
            if(reMsg) {
              div.innerHTML = reMsg
              var forms=	document.querySelectorAll('#pay_no_replay  form')
              forms[0].submit()
            }
          })
        }else if(that.payMethod != 12104) {  //  12104 在线支付       12105协议欠款
          console.log(this.orderDetail,this,'000')
          that.$router.push({
            path: '/tk/paySuccess', query: {
              orderId: that.orderId,
              orderType: that.orderType,
            }
          })

        }else{  //   默认其他支付
          that.$nextTick(function() {
            if(reMsg) {
              div.innerHTML = reMsg
              var forms=	document.querySelectorAll('#pay_no_replay  form')
              forms[0].submit()
            }
          })
        }
      },(res) => {
        if (res.errCode==2317) {
          that.$toast('请输入支付密码')
        } else if(res.errCode==2318) {
          that.$toast('支付密码不正确，请联系管理员。')
        } else {
          that.$toast(res.tips)
        }
      })
    },
    // 订单支付备注
    getPayRemark (orderType) {
      let obj = {
        // 机票正常单
        '11001':() => `${this.orderDetail.voyageZh}  ${this.orderDetail.orderRangeBeanList[0]['departDate']}`,
        '11004':() => `${this.orderDetail.voyageZh}  ${this.orderDetail.orderRangeBeanList[0]['departDate']}`,
        // 机票改签正常单
        '11003':() => `${this.alterOrderDetail.voyageZh}  ${this.alterOrderDetail.rangeList[0]['nDepartDate']}`,
        '11006':() => `${this.alterOrderDetail.voyageZh}  ${this.alterOrderDetail.rangeList[0]['nDepartDate']}`,
        //火车票正常单
        '11009': () => `${this.orderDetail.fromStationName} - ${this.orderDetail.toStationName}  ${this.orderDetail.fromDate} ${this.orderDetail.trainCode} ${this.orderDetail.seatTypeName}`,
        // 火车票 改签单
        '11011': () => this.orderDetail.newFromStationName + '-' + this.orderDetail.newToStationName + ' ' + this.orderDetail['newFromDate'] + ' ' + this.orderDetail.newTrainCode + ' ' + this.orderDetail.newSeatTypeName,
        // 酒店正常单
        '11007': () => this.orderDetail.cityName + ' ' + this.orderDetail.jdmc + ' ' + this.orderDetail.fxmc + +' ' + this.orderDetail.nights + '晚' + ' ' + '房间数' + this.orderDetail.rooms + ' ' + '入住日期' + this.orderDetail.rzrq + ' ' + this.orderDetail.ldrq,
        // 用车订单
        '11018': () => this.orderDetail.cityName + ' ' + this.orderDetail.startTime +' ' + this.orderDetail.orderTypeName +' ' +this.orderDetail.vehicleTypeName + ' ' +this.orderDetail.useDays+'天 '+ this.orderDetail.rangeType==1?'市郊':'跨城',
        // 机场服务
        '11028': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
        '11029': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
        '11030': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
        '11031': () => this.orderDetail.cityName + ' ' + this.orderDetail.airportName+' ' +this.orderDetail.terminal+' '+this.orderDetail.serviceName+' '+this.orderDetail.serviceType,
        // '11019': () => this.orderDetail.placeName + ' ' + this.orderDetail.terminal +' ' +this.orderDetail.passenger +' '+this.orderDetail.flightNo +' '+ this.orderDetail.totalPrice +' '+this.orderDetail.flightDate,
        '11023': () => this.orderDetail.visaName + ' ' + this.orderDetail.tripDate +' ' +this.orderDetail.psgNameStr +' '+this.orderDetail.totalPrice +' '+this.orderDetail.consularDist
      }
      if (obj[orderType]) {
        return obj[orderType]()
      }
      return ''
    },
    // 多科目支付 获得支付价格
    getPayAmount (item) {
      if (this.orderType == '11007') {//酒店订单
        return (item.subjectId=='1210501'?this.orderDetail.gszfje:(this.orderDetail.grzfje||0))
      }
      return 0
    },
    // 二维码 回调
    callback (res) {
      this.dataBase=res
    },
    cancel () {
      clearInterval(timers.tId)
    },
    confirm () { //点击保存相册
      var that = this
      // if (isH5()) { //非h5环境下执行
      // 	var ws = plus.webview.currentWebview()
      // 	let b = new plus.nativeObj.Bitmap()
      // 	ws.draw(b, function () {
      // 		console.log('截屏绘制图片成功')
      // 	}, function (e) {
      // 		console.log('截屏绘制图片失败：' + JSON.stringify(e))
      // 	})
      // 	b.save('_www/img2.jpg', { overwrite: true }, function () {
      // 		console.log('保存成功')
      // 		plus.gallery.save('_www/img2.jpg', function () {
      // 			let b = document.getElementById('link')
      // 			b.href = 'weixin://' //'alipayqr://platformapi/startapp?saId=10000007&qrcode='+this.reMsg
      // 			b.click()
      // 			console.log('保存图片到相册成功')
      // 		}, function () {
      // 			console.log('保存图片到相册失败')
      // 		})
      // 	}, function () {
      // 		console.log('保存失败')
      // 	})
      // }
      let a = document.getElementById('link')
      a.href = 'weixin://' //'alipayqr://platformapi/startapp?saId=10000007&qrcode='+this.reMsg
      a.click()
      setTimeout(function () {
        that.$dialog.confirm({
          title: '提示',
          message: '',
          confirmButtonText:'已支付',
          cancelButtonText:'支付遇到问题',
        }).then(() => {
          that.$router.push({
            path: '/pay/paySuccess', query: {
              orderId: that.orderId, orderType: that.orderType
            }
          })
          clearInterval(timers.tId)
        }).catch(() => {
          that.$toast('请重新发起支付')
          clearInterval(timers.tId)
        })
      },6000)
    },
    save () {
      var that=this
      if (isH5()==false) { //非h5环境下执行
        var actionList = {title:'操作',cancel:'取消',buttons:[{title:'保存图片到相册'}]}
        //弹出actionSheet选项
        plus.nativeUI.actionSheet(actionList, function (e) {
          if (e.index == 1) {
            var PHPhotoLibrary = plus.ios.import('PHPhotoLibrary')
            var authStatus = PHPhotoLibrary.authorizationStatus()
            if (authStatus == 3) {
              console.log('相册权限已经开启')
            } else {
              that.$toast('相册权限没有开启,请开启或手动截屏')
            }
            plus.ios.deleteObject(PHPhotoLibrary)

            // 截屏绘制
            let b = new plus.nativeObj.Bitmap()
            b.loadBase64Data(that.dataBase, function () {
              console.log('创建成功')
            }, function () {
              console.log('创建失败')
            })

            b.save('_www/imgs.jpg', { overwrite: true }, function () {
              plus.gallery.save('_www/imgs.jpg', function () {
                // let b = document.getElementById('link')
                // b.href = 'weixin://' //'alipayqr://platformapi/startapp?saId=10000007&qrcode='+this.reMsg
                // b.click()
                // res.target
                that.$toast('保存图片到相册成功')
                that.confirm()
                console.log('保存图片到相册成功')
              }, function () {
                console.log('保存图片到相册失败')
              })
            }, function () {
              console.log('保存失败')
            })
          }
        })
      }
    },
    upsdkReady(tnNo,that) {
      upsdk.pluginReady(function () {
        // 插件调用
        upsdk.pay({
          tn: tnNo,
          success: function () {
            // 支付成功，开发者执行后续操作
            // that.$toast("支付成功");
            Bussiness.toOrderDetail({id:that.orderId,orderType:that.orderType}) //跳转订单详情
          },
          fail: function (err) {
            // 支付失败，err.msg 是失败原因描述，比如TN号不合法，或者用户取消了交易等等
            that.$toast(err.msg)
          },
        })
      })
    },
    // 公众号支付
    onBridgeReady (params) {
      var that = this
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', params,
        //  {
        //     'appId':'wx2421b1c4370ec43b',     //公众号名称，由商户传入
        //     'timeStamp':'1395712654',         //时间戳，自1970年以来的秒数
        //     'nonceStr':'e61463f8efa94090b1f366cccfbbb444', //随机串
        //     'package':'prepay_id=u802345jgfjsdfgsdg888',
        //     'signType':'MD5',         //微信签名方式：
        //     'paySign':'70EA570631E4BB79628FBCA90534C63FF7FADD89' //微信签名
        // }
        function(res){
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            console.log('支付返回！',res)
          }
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          that.$dialog.confirm({
            title: '提示',
            message: '',
            confirmButtonText:'已支付',
            cancelButtonText:'支付遇到问题',
          }).then(() => {
            that.$router.push({
              path: '/pay/paySuccess', query: {
                orderId: that.orderId, orderType: that.orderType
              }
            })
          }).catch(() => {
            that.$toast('请重新发起支付')
          })
        })
    },
    // -------------------选择支付科目-----------------
    toChoosePayType (payItem) {
      setTimeout(() => {
        if (this.manySubjects) {
          // 多选
          this.isShowPay = (this.manySubjectsArr.length > 1 ? true : false)
          return
        } else {
          // 单选
          this.payMethod = payItem.payMethod
          this.paySubject = payItem.subjectId
          this.subjectName = payItem.subjectName
          this.zxzf = payItem.zxzf
          this.zxzf1 = payItem.zflx
          this.isShowPay=true
        }
      })
    },
    // 返回 默认 返回 至全部订单列表
    goback() {
      this.$router.push('/allorder?findType=2')
    },
  },
  filters: {
    payicon (val) {//支付图标
      let obj = {
        'ali100':alipay,
        'ali101':alipay,
        'ali102':alipay,
        'wx200':weixin,
        'wx201':weixin,
        'wx202':weixin,
        'YL001':yinlian,
        'YL002':yinlian,
        'YL003':yinlian,
        '12105': xieyi,
        'cmb':cmb,
        'ylcp': ysf
      }
      return obj[val.zxzf]||obj[val.payMethod]
    },
    DateYueOrRi(val) {
      var gao, hao
      if(val) {
        gao = val.substr(5, val.length - 5).split('-')
        hao = gao[0] + '月' + gao[1] + '日'
      }
      return(hao || '')
    },
    //  过滤上车地点
    filterScdd(val){
      if(val == 3){
        return '上车地点'
      }else if(val == 4){
        return '接机地点'
      }else if(val == 5){
        return '上车地点'
      }else if(val == 6){
        return '送站地点'
      }else if(val == 7){
        return '上车地点'
      }else {
        return '上车地点'
      }
    },
    filterXcdd(val){
      if(val == 5){
        return '送机地点'
      }else if(val ==7){
        return '送站地点'
      }else{
        return '下车地点'
      }
    },
    icon(val) {
      let obj = {
        11001: 'icondingdanlie-feiji',//icon_tk,
        11002: 'icondingdanlie-feiji',//icon_tk,
        11003: 'icondingdanlie-feiji',//icon_tk,
        11004: 'icondingdanlie-feiji',//icon_tk,
        11005: 'icondingdanlie-feiji',//icon_tk,
        11006: 'icondingdanlie-feiji',//icon_tk,
        11007: 'icondingdanlie-jiudian',//icon_ht,
        11008: 'icondingdanlie-jiudian',//icon_ht,
        11009: 'icondingdanlie-huoche',//icon_tr,
        11010: 'icondingdanlie-huoche',//icon_tr,
        11011: 'icondingdanlie-huoche',//icon_tr,
        11018: 'icondingdanlie-yongche',//icon_car,
        11023: 'icondingdanlie-qianzheng',//icon_visa,
        11028: 'icondingdanlie-xiuxishi',
        11029: 'icondingdanlie-kuaisuanjian',
        11030: 'icondingdanlie-youxianzhiji',
        11031: 'icondingdanlie-yaoketong',
      }
      return obj[val]
    },
    color(val){
      let obj = {
        11001: '#dbab56',//icon_tk,
        11002: '#dbab56',//icon_tk,
        11003: '#dbab56',//icon_tk,
        11004: '#dbab56',//icon_tk,
        11005: '#dbab56',//icon_tk,
        11006: '#dbab56',//icon_tk,
        11007: '#ffb757',//icon_ht,
        11008: '#ffb757',//icon_ht,
        11009: '#6452ef',//icon_tr,
        11010: '#6452ef',//icon_tr,
        11011: '#6452ef',//icon_tr,
        11018: '#51a5f2',//icon_car,
        11023: '#ed7f4f',//icon_visa,
        11028: '#f7bc33',
        11029: '#a1d656',
        11030: '#3ed9e5',
        11031: '#4e95ea',
      }
      return obj[val]
    },
    setOutModel(type){
      var obj={'0':'国内出发/国际出发','1':'国内出发','2':'国内到达','3':'国际出发','4':'国际到达'}
      return obj[type]||''
    }
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (to.name == 'paySuccess' && this.ssoParam && this.ssoParam.returnUrl) {
      window.location.href = this.ssoParam.returnUrl
    } else {
      next()
    }

  },
}
